// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.careers-page {
  padding-top: 6rem;
  min-height: 85vh;
  padding-bottom: 4rem;
}

.careers-hero {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3.5rem;
}

.careers-hero-desc {
  color: var(--text-muted);
  font-size: 1.15rem;
  line-height: 1.7;
  margin-top: 1rem;
}

.careers-perks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 4rem;
}

.perk-card {
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid var(--border-bento);
  border-radius: 16px;
  padding: 1.75rem;
  transition: transform 0.25s ease, border-color 0.25s ease;
}

.perk-card:hover {
  transform: translateY(-4px);
  border-color: rgba(245, 158, 11, 0.35);
}

.perk-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}

.perk-card h3 {
  font-size: 1.15rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.perk-card p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
}

.section-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.section-header h2 {
  font-size: 2rem;
  color: #ffffff;
  margin-top: 0.5rem;
}

.jobs-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 4rem;
}

.job-card {
  background: rgba(15, 23, 42, 0.75);
  border: 1px solid var(--border-bento);
  border-radius: 16px;
  padding: 1.75rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  transition: all 0.25s ease;
}

.job-card:hover {
  border-color: rgba(245, 158, 11, 0.4);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.job-info h3 {
  font-size: 1.35rem;
  color: #ffffff;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.job-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.job-tag {
  background: rgba(255, 255, 255, 0.06);
  color: #cbd5e1;
  font-size: 0.78rem;
  padding: 0.25rem 0.65rem;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.job-tag.location {
  color: #f59e0b;
  border-color: rgba(245, 158, 11, 0.2);
}

.job-desc {
  color: var(--text-muted);
  font-size: 0.92rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.job-skills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.skill-pill {
  font-size: 0.75rem;
  color: #94a3b8;
  background: rgba(11, 15, 23, 0.8);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.job-action {
  align-self: center;
  flex-shrink: 0;
}

.btn-apply {
  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);
  color: #000000;
  font-weight: 700;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 0.92rem;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  text-decoration: none;
}

.btn-apply:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
}

.careers-apply-box {
  background: rgba(15, 23, 42, 0.85);
  border: 1px solid var(--border-bento);
  border-radius: 20px;
  padding: 3rem 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.careers-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 1.75rem;
}

.form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

.careers-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.careers-field label {
  font-size: 0.88rem;
  color: #e2e8f0;
  font-weight: 600;
}

.careers-input,
.careers-select,
.careers-textarea {
  background: rgba(11, 15, 23, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 0.75rem 1rem;
  color: #ffffff;
  font-size: 0.92rem;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.careers-input:focus,
.careers-select:focus,
.careers-textarea:focus {
  border-color: rgba(245, 158, 11, 0.5);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

.careers-select option {
  background: #0f172a;
  color: #ffffff;
}

.success-alert {
  background: rgba(34, 197, 94, 0.12);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #4ade80;
  padding: 1rem;
  border-radius: 10px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .job-card {
    flex-direction: column;
  }
  .job-action {
    align-self: stretch;
    width: 100%;
  }
  .btn-apply {
    width: 100%;
    justify-content: center;
  }
  .form-grid-2 {
    grid-template-columns: 1fr;
  }
  .careers-apply-box {
    padding: 2rem 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Careers.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,wDAAwD;EACxD,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".careers-page {\n  padding-top: 6rem;\n  min-height: 85vh;\n  padding-bottom: 4rem;\n}\n\n.careers-hero {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 3.5rem;\n}\n\n.careers-hero-desc {\n  color: var(--text-muted);\n  font-size: 1.15rem;\n  line-height: 1.7;\n  margin-top: 1rem;\n}\n\n.careers-perks-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 4rem;\n}\n\n.perk-card {\n  background: rgba(15, 23, 42, 0.7);\n  border: 1px solid var(--border-bento);\n  border-radius: 16px;\n  padding: 1.75rem;\n  transition: transform 0.25s ease, border-color 0.25s ease;\n}\n\n.perk-card:hover {\n  transform: translateY(-4px);\n  border-color: rgba(245, 158, 11, 0.35);\n}\n\n.perk-icon {\n  font-size: 2rem;\n  margin-bottom: 0.75rem;\n}\n\n.perk-card h3 {\n  font-size: 1.15rem;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.perk-card p {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 2.5rem;\n}\n\n.section-header h2 {\n  font-size: 2rem;\n  color: #ffffff;\n  margin-top: 0.5rem;\n}\n\n.jobs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  margin-bottom: 4rem;\n}\n\n.job-card {\n  background: rgba(15, 23, 42, 0.75);\n  border: 1px solid var(--border-bento);\n  border-radius: 16px;\n  padding: 1.75rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1.5rem;\n  transition: all 0.25s ease;\n}\n\n.job-card:hover {\n  border-color: rgba(245, 158, 11, 0.4);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.job-info h3 {\n  font-size: 1.35rem;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n  font-weight: 700;\n}\n\n.job-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.85rem;\n}\n\n.job-tag {\n  background: rgba(255, 255, 255, 0.06);\n  color: #cbd5e1;\n  font-size: 0.78rem;\n  padding: 0.25rem 0.65rem;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.job-tag.location {\n  color: #f59e0b;\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n.job-desc {\n  color: var(--text-muted);\n  font-size: 0.92rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n.job-skills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.skill-pill {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  background: rgba(11, 15, 23, 0.8);\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n}\n\n.job-action {\n  align-self: center;\n  flex-shrink: 0;\n}\n\n.btn-apply {\n  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);\n  color: #000000;\n  font-weight: 700;\n  padding: 0.75rem 1.5rem;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-size: 0.92rem;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  text-decoration: none;\n}\n\n.btn-apply:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);\n}\n\n.careers-apply-box {\n  background: rgba(15, 23, 42, 0.85);\n  border: 1px solid var(--border-bento);\n  border-radius: 20px;\n  padding: 3rem 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.careers-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  margin-top: 1.75rem;\n}\n\n.form-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.25rem;\n}\n\n.careers-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.careers-field label {\n  font-size: 0.88rem;\n  color: #e2e8f0;\n  font-weight: 600;\n}\n\n.careers-input,\n.careers-select,\n.careers-textarea {\n  background: rgba(11, 15, 23, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  color: #ffffff;\n  font-size: 0.92rem;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.careers-input:focus,\n.careers-select:focus,\n.careers-textarea:focus {\n  border-color: rgba(245, 158, 11, 0.5);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);\n}\n\n.careers-select option {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.success-alert {\n  background: rgba(34, 197, 94, 0.12);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #4ade80;\n  padding: 1rem;\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .job-card {\n    flex-direction: column;\n  }\n  .job-action {\n    align-self: stretch;\n    width: 100%;\n  }\n  .btn-apply {\n    width: 100%;\n    justify-content: center;\n  }\n  .form-grid-2 {\n    grid-template-columns: 1fr;\n  }\n  .careers-apply-box {\n    padding: 2rem 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
